export enum CheckoutTypeEnum {
  ALL = 0,
  PHARMACY_SHIPPING = 1,
  USER_ADDRESS_SHIPPING = 2,
}

export enum CheckoutStatusEnum {
  DELETED = 0,
  CREATED_PHARMACY = 1,
  CSV_GENERATED = 2,
  ERROR_CSV = 3,
  SAP_PROCESSED = 4,
  SAP_ERROR = 5,
  CREATED_USER_SHIPPING = 6,
  PROCESSED_USER_SHIPPING = 7,
  ERROR_USER_SHIPPING = 8,
}

export enum ResourceCheckoutReplayTypeEnum {
  CHECKOUT_PRODUCT = 34,
  CHECKOUT_DONATION = 67,
  CHECKOUT_LOTTERY = 61,
  CHECKOUT_BOOKING_TIMIFY = 75,
}
